var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrdCategory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 60,
    viewBox: "0 0 52 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_478_9247)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1673 0H1.97455C0.883636 0 0 0.883636 0 1.97455V23.4218C0 23.9018 0.250909 24.3491 0.676364 24.5673C1.09091 24.8073 1.60364 24.7964 2.00727 24.5345L9.86182 19.5927C10.2873 19.32 10.8327 19.32 11.2582 19.5927L19.1127 24.5345C19.7236 24.9164 20.5418 24.7309 20.9236 24.12C21.0545 23.9127 21.12 23.6727 21.12 23.4218V1.97455C21.12 0.883636 20.2364 0.0109091 19.1455 0H19.1673Z",
    fill: "#CCE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7016 0H32.498C31.4071 0 30.5234 0.883636 30.5234 1.97455V23.4218C30.5234 23.9018 30.7743 24.3491 31.1998 24.5673C31.6143 24.8073 32.1271 24.7964 32.5307 24.5345L40.3853 19.5927C40.8107 19.32 41.3562 19.32 41.7816 19.5927L49.6362 24.5345C50.2471 24.9164 51.0653 24.7309 51.4471 24.12C51.578 23.9127 51.6434 23.6727 51.6434 23.4218V1.97455C51.6434 0.883636 50.7598 0.0109091 49.6689 0H49.7016Z",
    fill: "#CCE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8002 4.88721H38.4002C37.2073 4.88721 36.2402 5.85427 36.2402 7.04721V12.4472C36.2402 13.6401 37.2073 14.6072 38.4002 14.6072H43.8002C44.9932 14.6072 45.9602 13.6401 45.9602 12.4472V7.04721C45.9602 5.85427 44.9932 4.88721 43.8002 4.88721Z",
    fill: "#027BC7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7016 35.1926H32.498C31.4071 35.1926 30.5234 36.0763 30.5234 37.1672V58.6145C30.5234 59.0944 30.7743 59.5417 31.1998 59.7599C31.6143 59.9999 32.1271 59.989 32.5307 59.7272L40.3853 54.7854C40.8107 54.5126 41.3562 54.5126 41.7816 54.7854L49.6362 59.7272C50.2471 60.109 51.0653 59.9235 51.4471 59.3126C51.578 59.1054 51.6434 58.8654 51.6434 58.6145V37.1672C51.6434 36.0763 50.7598 35.2035 49.6689 35.1926H49.7016Z",
    fill: "#CCE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4294 40.5274L35.7712 48.5892C35.4767 49.1019 35.8476 49.7455 36.4367 49.7455H45.7421C46.3312 49.7455 46.7131 49.1019 46.4076 48.5892L41.7494 40.5274C41.4549 40.0146 40.7131 40.0146 40.4076 40.5274H40.4294Z",
    fill: "#019EF7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1673 35.1927H1.97455C0.883636 35.1927 0 36.0764 0 37.1673V58.6146C0 59.0946 0.250909 59.5418 0.676364 59.76C1.09091 60 1.60364 59.9891 2.00727 59.7273L9.86182 54.7855C10.2873 54.5128 10.8327 54.5128 11.2582 54.7855L19.1127 59.7273C19.7236 60.1091 20.5418 59.9237 20.9236 59.3128C21.0545 59.1055 21.12 58.8655 21.12 58.6146V37.1673C21.12 36.0764 20.2364 35.2037 19.1455 35.1927H19.1673Z",
    fill: "#CCE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5712 49.7454C13.7041 49.7454 16.2439 47.2056 16.2439 44.0726C16.2439 40.9397 13.7041 38.3999 10.5712 38.3999C7.4382 38.3999 4.89844 40.9397 4.89844 44.0726C4.89844 47.2056 7.4382 49.7454 10.5712 49.7454Z",
    fill: "#027BC7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5534 8.68373L14.6079 11.4328C14.4661 11.5637 14.4007 11.771 14.4334 11.9565L15.197 15.9056C15.2625 16.211 15.0552 16.5165 14.7388 16.5819C14.6079 16.6037 14.4661 16.5819 14.357 16.5165L10.8443 14.5637C10.6698 14.4656 10.4625 14.4656 10.2879 14.5637L6.77521 16.5165C6.50248 16.6692 6.15339 16.571 6.00066 16.2983C5.93521 16.1783 5.91339 16.0474 5.93521 15.9165L6.69885 11.9674C6.74248 11.771 6.67703 11.5746 6.5243 11.4437L3.57885 8.69464C3.34976 8.47646 3.33885 8.11646 3.54612 7.88737C3.63339 7.78919 3.7643 7.72373 3.89521 7.71282L7.88794 7.22191C8.0843 7.2001 8.25885 7.0801 8.33521 6.89464L10.037 3.251C10.1679 2.96737 10.517 2.83646 10.8007 2.97828C10.9207 3.03282 11.0188 3.131 11.0734 3.251L12.7752 6.89464C12.8516 7.0801 13.0261 7.2001 13.2225 7.22191L17.2152 7.71282C17.5316 7.74555 17.7498 8.0401 17.717 8.34555C17.7061 8.47646 17.6407 8.60737 17.5425 8.69464L17.5534 8.68373Z",
    fill: "#28345A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_478_9247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.2727,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrdCategory);
export default __webpack_public_path__ + "static/media/prdCategory.9f1f919a22a072987b450597673cbe91.svg";
export { ForwardRef as ReactComponent };